export const apiBaseUrl = './company-agreement/api/v1'
